import axios from 'axios';

const HOST = window.location.host;
const instance = axios.create({
  baseUrl: 'https://' + HOST,
  // timeout: 5000,   // default : 0 (no timeout)
});

instance.interceptors.request.use(

  function (config) {
    const token = localStorage.getItem("token");
    config.headers["Content-Type"] = "multipart/form-data; charset=utf-8";
    config.headers["Authorization"] = "Bearer " + token;
    // console.log("__FILE__CONFIG:"+JSON.stringify(config));
    return config;
  },
  function (error) {
    console.log(error);
    return Promise.reject(error);
  }
);

export const FileService = {

  files: async (url, fd) => {
    // console.log("files::::"+url);
    // console.log("fd:::"+fd);
    return instance.post(url, fd);
  }
}
instance.interceptors.response.use(
  function (response) {
    //console.log("ResPONSE1:"+JSON.stringify(response));
    return response;

  },
  function (error) {
    //errorController(error);
  }
);
export default instance;